export enum MatIconType {
  ExternalIcon = 'open_in_new',
  DialogIcon = 'article',
  CommentIcon = 'comment',
  ReviewIcon = 'rate_review',
  Edit = 'edit',
  HelpOutline = 'help_outline',
  CancelIcon = 'block',
}